"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonutChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreDonutChart_1 = require("./CoreDonutChart");
var withChart_1 = require("../_base/withChart");
//
// Internals
//
var donutChartDefinition = {
    chartName: "DonutChart",
    bucketPropsKeys: ["measures", "viewBy", "filters", "sortBy"],
    bucketsFactory: function (props) {
        var measures = (Array.isArray(props.measures) ? props.measures : [props.measures]);
        return [
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.MEASURES], measures)),
            sdk_model_1.newBucket(sdk_ui_1.BucketNames.VIEW, props.viewBy),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("DonutChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(dimensions_1.roundChartDimensions)
            .withExecConfig(execConfig);
    },
};
var WrappedDonutChart = withChart_1.withChart(donutChartDefinition)(CoreDonutChart_1.CoreDonutChart);
/**
 * [DonutChart](http://sdk.gooddata.com/gooddata-ui/docs/donut_chart_component.html)
 *
 * Donut chart shows data as proportional segments of a disc and has a hollowed out center.
 * Donut charts can be segmented by either multiple measures or an attribute, and allow viewers to visualize
 * component parts of a whole.
 *
 * Note: the donut chart slices are by default sorted from largest to smallest. There is also a limit on the
 * number of slices that will be charted.
 *
 * @public
 */
exports.DonutChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measures, props.viewBy, props.filters, props.sortBy], props.placeholdersResolutionContext), measures = _a[0], viewBy = _a[1], filters = _a[2], sortBy = _a[3];
    return (react_1.default.createElement(WrappedDonutChart, tslib_1.__assign({}, props, {
        measures: measures,
        viewBy: viewBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=DonutChart.js.map